import React from 'react';
/*
import {
  hf,
  ht,
  cr,
  gs,
  ls,
  a,
  cmFTH,
  BoxC,
  BtnC,
  GridC,
  IptC,
  LblC,
  MsgC,
  TextC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as GridC from "./_cccGridC";
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';

import * as icvI18___Ti from './icvI18___Ti';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  React.useEffect(() => {
    cmFTH.loadAllAsync({
    })
  }, [])

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
          lineCs: [{
            cellCs: [
              {
                oClds: [
                ]
              },
              {
                oClds: [
                  cr.c(icvI18___Ti.S, {
                    key: -10,
                    sPz: pz.sPz,
                  }),
                ]
              },
              {
                oClds: [
                ]
              },
            ]
          }]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

/*
            cr.c(icvI18___Ti.F, {
              key: -10,
              sPz: pz.sPz,
            }),
*/

            cr.c(icvI18___Ti.L, {
              key: -20,
              sPz: pz.sPz,
            }),

            cr.c(icvI18___Ti.B, {
              key: -30,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',
                onPrsBack: () => {
                  cr.moveTo({
                    pageName: 'icvHomeS10Rz',
                  });
                }
              }
            })

          ]
        })

      ]
    })
  );
};
